jQuery(function($) {

    /**
     * ActiveBanner
     * -----------
     * Steuert einen “Slide-in”-Banner, der standardmäßig offen ist und
     * nur dann dauerhaft zugeklappt bleibt, wenn der User ihn aktiv schließt.
     *
     * Verhalten:
     * - Erster Besuch (kein Cookie): Banner ist offen.
     * - User klickt "Schließen": Banner klappt zu und merkt sich das für 30 Tage.
     * - User klickt Seitenleiste (farbiger Streifen): Banner öffnet wieder und merkt sich das.
     * - Vollständig deaktivieren ist nicht möglich -> nur auf/zu.
     *
     * Technische Voraussetzungen:
     * - jQuery ist vorhanden
     * - jquery.cookie Plugin ist vorhanden (=> $.cookie())
     *
     * A11y-Erweiterungen:
     * - aria-expanded wird korrekt gesetzt
     * - aria-controls verbindet Toggle & Content
     * - aria-hidden + inert verhindern Tab-Fokus im geschlossenen Zustand
     * - ESC schließt Banner
     * - Fokus wird sinnvoll zurückgesetzt
     */

    const ActiveBanner = {

        /** jQuery-Referenz auf das Banner-Wrapper-Element */
        $el: null,

        /** Referenz auf Content-Bereich (für A11y-Steuerung) */
        $content: null,

        /** Referenz auf Toggle-Button (Seitenleiste) */
        $toggleButton: null,

        /** Referenz auf Close-Button */
        $closeButton: null,

        /**
         * CSS-Klasse, die den “offenen” Zustand markiert.
         * (CSS regelt das tatsächliche Rein-/Rausfahren per Transition.)
         */
        openClass: 'active-banner-wrapper-open',

        /**
         * Cookie-Konfiguration:
         * - name: Cookie-Name im Browser
         * - days: Gültigkeit in Tagen
         * - path: Cookie gilt auf der gesamten Domain
         */
        cookie: {
            baseName: 'activeBannerState',
            days: 30,
            path: '/'
        },

        /**
         * Initialisierung:
         * - Element finden
         * - gespeicherten Zustand anwenden
         * - Klick-Events registrieren
         */
        init(selector) {
            this.$el = $(selector);

            // Wenn das Banner-Element nicht existiert: nichts tun
            if (!this.$el.length) {
                return;
            }

            // UID aus data-Attribut lesen (Fallback: "global")
            this.bannerUid = this.$el.data('uid') || 'global';

            this.textAusklappen = this.$el.data('text-banner-ausklappen');
            this.textEinklappen = this.$el.data('text-banner-einklappen');

            // A11y: relevante Elemente referenzieren
            this.$content = this.$el.find('.banner-content');
            this.$toggleButton = this.$el.find('.banner-side');
            this.$closeButton = this.$el.find('.banner-close');

            // A11y: ARIA-Attribute initial setzen
            this.setupAccessibility();

            this.applyInitialState();
            this.bindEvents();
        },

        /**
         * Setzt grundlegende ARIA-Attribute:
         * - aria-controls am Toggle-Button
         * - eindeutige ID für Content-Bereich
         * - aria-expanded initial auf false
         */
        setupAccessibility() {
            const contentId = 'active-banner-content-' + this.bannerUid;

            this.$content.attr('id', contentId);

            this.$toggleButton.attr({
                'aria-controls': contentId,
                'aria-expanded': 'false'
            });
        },

        /**
         * Event-Handler registrieren (delegiert über document):
         * - Vorteil: funktioniert auch, wenn Banner später per AJAX nachgeladen wird.
         */
        bindEvents() {

            // Öffnen über die Seitenleiste / den farbigen Streifen
            $(document).on('click', '.banner-side', (e) => {
                e.preventDefault();
                e.stopPropagation();

                // Prüfen, ob Banner offen ist
                if (this.isOpen()) {
                    // Banner schließen und Zustand speichern
                    this.close(true);

                    // A11y: Fokus auf Toggle-Button setzen
                    // this.$toggleButton.focus();
                } else {
                    // Banner öffnen und Zustand speichern
                    this.openAndRemember();
                }
            });

            // Schließen über Pfeil / Close-Button
            $(document).on('click', '.banner-close', (e) => {
                e.preventDefault();
                e.stopPropagation();

                // Banner schließen und Zustand im Cookie speichern
                this.close(true);

                // A11y: Fokus zurück auf Toggle-Button setzen
                this.$toggleButton.focus();
            });

            /**
             * A11y:
             * ESC-Taste schließt Banner,
             * wenn er aktuell offen ist.
             */
            $(document).on('keydown', (e) => {
                if (e.key === 'Escape' && this.isOpen()) {
                    this.close(true);
                    this.$toggleButton.focus();
                }
            });
        },

        /**
         * Setzt den initialen Zustand anhand des Cookies.
         * - Wenn Cookie "closed": Banner zugeklappt
         * - Sonst (Cookie fehlt oder "open"): Banner offen
         */
        applyInitialState() {
            const state = this.getState();
            this.open(state !== 'closed');
        },

        /**
         * Prüft, ob Banner aktuell offen ist.
         */
        isOpen() {
            return this.$el.hasClass(this.openClass);
        },

        /**
         * Öffnet oder schließt den Banner durch Setzen/Entfernen der CSS-Klasse.
         * @param {boolean} shouldOpen true = offen, false = geschlossen
         */
        open(shouldOpen) {

            this.$el.toggleClass(this.openClass, shouldOpen);

            /**
             * A11y:
             * - aria-expanded korrekt setzen
             * - aria-hidden steuern
             * - inert verhindert Tab-Navigation im geschlossenen Zustand
             */
            this.$toggleButton.attr({
                'aria-expanded': shouldOpen
            });
            this.$toggleButton.find('span.sr-only').text(
                shouldOpen ? this.textEinklappen : this.textAusklappen
            );

            if (shouldOpen) {

                this.$content
                    .removeAttr('inert')
                    .attr('aria-hidden', 'false');

                /**
                 * A11y:
                 * Fokus beim Öffnen sinnvoll ins Panel setzen
                 */
                // const $firstFocusable = this.$content.find('a, button').first();
                // if ($firstFocusable.length) {
                //     $firstFocusable.focus();
                // }

            } else {

                this.$content.attr({
                    'aria-hidden': 'true',
                    'inert': ''
                });
            }
        },

        /**
         * Schließt den Banner.
         * @param {boolean} writeCookie Wenn true, wird der Zustand "closed" gespeichert.
         */
        close(writeCookie = true) {
            this.open(false);

            // Nur bei bewusstem Schließen (oder wenn gewünscht) merken
            if (writeCookie) {
                this.setState('closed');
            }
        },

        /**
         * Öffnet den Banner und speichert den Zustand "open".
         * Dadurch bleibt er auch nach Reloads offen, bis er wieder geschlossen wird.
         */
        openAndRemember() {
            this.open(true);
            this.setState('open');
        },

        // Cookie-Name pro Banner
        getCookieName() {
            return `${ this.cookie.baseName }_${ this.bannerUid }`;
        },

        /**
         * Liest den gespeicherten Zustand aus dem Cookie.
         * @returns {string|null} "open" | "closed" | null (wenn Cookie nicht existiert)
         */
        getState() {
            return $.cookie(this.getCookieName()) || null;
        },

        /**
         * Schreibt den Zustand in den Cookie.
         * @param {string} value Erwartet "open" oder "closed"
         */
        setState(value) {
            $.cookie(this.getCookieName(), value, {
                expires: this.cookie.days,
                path: this.cookie.path
            });
        }
    };

    // Banner initialisieren
    ActiveBanner.init('#active-banner-wrapper');

});
